import React, {useState, useEffect} from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import {
    Grid,
    Typography
} from '@deere/fuel-react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {toCapitalize} from "../utils";
import {useAuthConfig} from "../helper";
import {useStyles} from "../styles/Filter";
import { getOptionSelectedByField } from '../utils/autocompleteUtils';

export const TeamMemberFilter = ({expanded, onExpandClick, title, selectedTeamMembers, onOptionsChange}) => {
    let authAxios = useAuthConfig();
    const classes = useStyles();
    const [options, setOptions] = useState([]);
    const [selectedTeamMemberOptions, setSelectedTeamMemberOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const processSearchName = data => {
        const updatedList = []
        data.forEach((item) => {
            const searchHelperObj = {description: `${item.lastName},${item.firstName}-${item.racfID}`}
            item = {...item, ...searchHelperObj};
            updatedList.push(item)
        });
        setOptions(updatedList)
    }

    const handleChangeValues = (event, value) => {
        sessionStorage.setItem("selectedTeamMembers", JSON.stringify(value));
        setSelectedTeamMemberOptions(value);
        onOptionsChange(value)
    }

    const getPeople = async (value) => {
        setLoading(true)
        try {
            await authAxios.get(`/user/search?searchStr=${value}`).then(res => {
                processSearchName(res.data)
                setLoading(false)
            })
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    };
    useEffect(() => {
        setSelectedTeamMemberOptions(sessionStorage["selectedTeamMembers"] ? JSON.parse(sessionStorage.getItem("selectedTeamMembers")) : selectedTeamMembers);
    }, [selectedTeamMembers]);

    return (
        <div className={classes.root}>
            <Accordion expanded={expanded === "owner"}
                       onChange={onExpandClick("owner")}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{content: classes.content, expanded: classes.expanded}}
                    expandIcon={<ExpandMoreIcon style={{fontSize: '2rem'}}/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>{title}</Typography>
                        </Grid>
                        {!expanded && (
                            <Grid item xs={12}>
                                {selectedTeamMemberOptions ? selectedTeamMemberOptions.map((data, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <CheckIcon style={{color: "#367c2b", marginRight: "1rem"}}
                                                       display="inline"/>
                                            <Typography
                                                display="inline"
                                                key={data.racfID}>{data.lastName && toCapitalize(data.lastName)}, {data.firstName && toCapitalize(data.firstName)}</Typography>
                                            <br/>
                                        </React.Fragment>)
                                }) : ""
                                }
                            </Grid>
                        )}
                    </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.root}>
                    <Autocomplete
                        multiple
                        fullWidth
                        size="small"
                        id="people-find"
                        options={options}
                        defaultValue={selectedTeamMemberOptions}
                        value={selectedTeamMemberOptions}
                        getOptionLabel={(option) => option.racfID ? `${option.lastName && toCapitalize(option.lastName)}, ${option.firstName && toCapitalize(option.firstName)} - ${option.racfID}` : ""}
                        getOptionSelected={getOptionSelectedByField('racfID')}
                        loading={loading}
                        onChange={handleChangeValues}
                        onInputChange={(e, value) => {
                            if (value.length > 2)
                                getPeople(value)
                        }}
                        renderInput={(params) => <TextField {...params}
                                                            placeholder="Search By Last Name or User ID"
                                                            variant="outlined"/>}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
